import { Button, Col, Container, Row } from "react-bootstrap";
import { ClockFill, TelephoneFill } from "react-bootstrap-icons";

// ছোট ডট কম্পোনেন্ট - যা শুধু একটি ইনডিকেটর হিসেবে কাজ করবে
const SimpleDot = () => (
  <>
    <style>{`
      @keyframes dot-pulse {
        0%   { transform: scale(1);   opacity: 1;    box-shadow: 0 0 0 0 rgba(31, 255, 31, 0.7); }
        50%  { transform: scale(1.2); opacity: 0.9;  box-shadow: 0 0 0 6px rgba(31, 255, 31, 0); }
        100% { transform: scale(1);   opacity: 1;    box-shadow: 0 0 0 0 rgba(31, 255, 31, 0); }
      }

      .service-indicator-dot {
        height: 10px;
        width: 10px;
        background-color: #1FFF1F;
        border-radius: 50%;
        display: inline-block;
        margin-right: 10px;
        flex-shrink: 0;
        animation: dot-pulse 2s infinite;
      }
    `}</style>
    <span className="service-indicator-dot"></span>
  </>
);

const ContactCTAStyle = () => (
  <style>{`
    

    .cta-animate-pulse {
      animation: cta-pulse-red 2s infinite;
    }

    .cta-animate-pulse:hover {
      animation: none;
    }

    @keyframes cta-pulse-red {
      0%   { transform: scale(1); }
      50%  { transform: scale(1.05); }
      100% { transform: scale(1); }
    }

    /* Responsive */
    @media (max-width: 991px) {
      .cta-section-wrap { padding: 20px 10px; }
    }

    @media (max-width: 576px) {
      .cta-section-wrap { padding: 10px 10px; }
   
      .cta-body-text     { font-size: 16px !important; line-height: 1.8 !important; }
      .cta-phone-btn     { font-size: 16px !important; padding: 8px 8px !important; }
      .cta-accent-text   { font-size: 0.8rem !important; }
      .cta-note-text     { font-size: 12px !important; }
    }
  `}</style>
);

const ContactCTA = () => {
  const styles = {
    section: {
      background: "linear-gradient(180deg, #b22335 0%, #b22335 100%)",
      padding: "30px 10px",
      fontFamily: "hauora-medium, sans-serif",
    },
    heading: {
      color: "#f9f9fb",
      fontFamily: "hauora-medium, sans-serif",
    },
    bodyText: {
      color: "#fefeff",
      fontFamily: "hauora-medium, sans-serif",
      fontSize: "19px",
      lineHeight: "1.9",
    },
    phoneBtn: {
      backgroundColor: "#b22335",
      borderColor: "#b22335",
      color: "#ffffff",
      fontFamily: "hauora-medium, sans-serif",
      fontSize: "calc(0.6rem + 0.55vw)",
      padding: "10px 10px",
      boxShadow: "0 4px 15px rgba(230, 195, 199, 0.3)",
    },
    callNow: {
      color: "#ffffff",
      opacity: 0.85,
    },
    noteText: {
      color: "#fbfbff",
      fontFamily: "hauora-medium, sans-serif",
      fontSize: "15px",
    },
  };

  return (
    <>
      <ContactCTAStyle />
      <section className="cs-section cta-section-wrap" style={styles.section}>
        <Container>
          <Row className="align-items-center gy-4">
            {/* Left Content */}
            <Col lg={8}>
              <h2 className="cs-title cta-heading-text" style={styles.heading}>
                <ClockFill className="me-3" />
                Roof 24/7 Emergency Service in Dublin, Ohio?{" "}
                <span style={styles.callNow}>Call Now!</span>
              </h2>
              <p className="cs-desc cta-body-text" style={styles.bodyText}>
                <strong>
                  Roof problems don't wait—and neither should you.
                </strong>{" "}
                That's why we offer 24/7 emergency commercial &amp; residential
                roofing services in Dublin, Ohio.
              </p>
              <p className="cs-desc cta-body-text" style={styles.bodyText}>
                Whether it's storm damage, a sudden leak, or fallen debris, our
                team responds quickly to prevent further damage to your home or
                business.
              </p>
            </Col>

            {/* Right Content - Button & Emergency Text with Dot */}
            <Col lg={4} className="text-center">
              <Button
                href="tel:+1 (614) 357-7539"
                style={styles.phoneBtn}
                className="cta-phone-btn rounded-pill cta-animate-pulse"
              >
                <TelephoneFill className="me-1" /> +1 (614) 357-7539
              </Button>

              <div
                className="cta-note-text mt-3 d-flex align-items-center justify-content-center"
                style={styles.noteText}
              >
                <SimpleDot />
                <span>Roof 24/7 Emergency Service</span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ContactCTA;
